import { useEffect } from 'react';

const keyHandler = ({ keyCode, key }, handleClose) => {
    if (keyCode === 27 || key === 'Escape') {
        handleClose();
    }
};

const useEscapeKeypress = (handleClose) => {
    return useEffect(() => {
        if (open) {
            window.addEventListener('keydown', e => keyHandler(e, handleClose));
        } else {
            window.removeEventListener('keydown', e => keyHandler(e, handleClose));
        }
        return () => {
            window.removeEventListener('keydown', e => keyHandler(e, handleClose));
        };
    }, [open]);
};
export default useEscapeKeypress;
